module.exports = __webpack_public_path__ + "img/perspectives-slide09.127b782e.jpg";